import {
  BedDouble,
  BookOpen,
  Briefcase,
  Car,
  Dumbbell,
  Gift,
  Headset,
  Home,
  Landmark,
  Map,
  MessageSquareQuote,
  PackageX,
  PartyPopper,
  PawPrint,
  Phone,
  Plane,
  Scissors,
  Sparkles,
  Stethoscope,
  TrendingUp,
  Users,
  UtensilsCrossed,
  type LucideIcon,
} from 'lucide-react';
import type { PracticeKind } from './types';

/** Иконки ролевых игр — имя строкой приходит с бэка (см. seed-practice.ts), здесь только резолв в компонент. */
const PRACTICE_ICONS: Record<string, LucideIcon> = {
  Map,
  Gift,
  Headset,
  BookOpen,
  Briefcase,
  Home,
  UtensilsCrossed,
  PackageX,
  BedDouble,
  Stethoscope,
  Car,
  Scissors,
  Phone,
  Users,
  PartyPopper,
  TrendingUp,
  Plane,
  PawPrint,
  Landmark,
  Dumbbell,
};

/**
 * У идиом (в отличие от ролевых игр) бэк вообще не хранит иконку (см.
 * `seedIdioms` в seed-practice.ts — `icon` там не передаётся), поэтому им
 * всегда достаётся один и тот же смысловой фолбэк («цитата»), а не общий
 * Sparkles «иконки нет вовсе».
 */
export function practiceIconFor(icon: string | null, kind?: PracticeKind): LucideIcon {
  if (icon && PRACTICE_ICONS[icon]) return PRACTICE_ICONS[icon];
  return kind === 'idiom' ? MessageSquareQuote : Sparkles;
}
